import React, { useEffect, useState } from 'react';

import { MapContainer, Marker, Popup, TileLayer, useMap } from '@monsonjeremy/react-leaflet';

import L from "leaflet";


import { UfficioMarker } from './UfficioMarker';

const LocationMarker = () => {
    const [position, setPosition] = useState(null);
    const [bbox, setBbox] = useState([]);

    const map = useMap();

    useEffect(() => {
        map.locate().on("locationfound", function (e) {
            setPosition(e.latlng);
            map.flyTo(e.latlng, map.getZoom() * 2);
            setBbox(e.bounds.toBBoxString().split(","));
        });
    }, [map]);

    return position === null ? null : (
        <Marker position={position}>
            <Popup>
                You are here. <br />
                Map bbox: <br />
                <b>Southwest lng</b>: {bbox[0]} <br />
                <b>Southwest lat</b>: {bbox[1]} <br />
                <b>Northeast lng</b>: {bbox[2]} <br />
                <b>Northeast lat</b>: {bbox[3]}
            </Popup>
        </Marker >
    );
}

const MapOptions = ({ onMoveEnd, ...props }) => {
    const map = useMap();

    useEffect(() => {
        map.attributionControl.setPrefix(null);
        map.on('moveend', onMoveEnd);
    }, [])

    return null;
}

const cuffs = new L.Icon({
    iconUrl: "/handcuffs.svg",
    iconSize: [25, 25]
});

const icons = {};
const fetchIcon = (count, size) => {
    if (!icons[count]) {
        icons[count] = L.divIcon({
            html: `<div class="cluster-marker" style="width: ${size}px; height: ${size}px; color: #fff;
            background: #1978c8;
            border-radius: 50%;
            padding: 10px;
            width: 10px;
            height: 10px;
            display: flex;
            justify-content: center;
            align-items: center;">
          ${count}
        </div>`
        });
    }
    return icons[count];
};

export const UfficioMap = ({ ufficiData, mapRef, markerRefs, initialZoom, ...props }) => {

    const points = ufficiData?.map(ufficioData => {
        return {
            "type": "Feature",
            "properties": {
                "cluster": false,
                "crimeId": ufficioData.id,
            },
            "geometry": { "type": "Point", "coordinates": [ufficioData.longitudine, ufficioData.latitudine] },
            ...ufficioData
        }
    });

    const [bounds, setBounds] = useState(null);
    const [zoom, setZoom] = useState(initialZoom)

    function updateMap() {

        const b = mapRef.current.getBounds();
        setBounds([
            b.getSouthWest().lng,
            b.getSouthWest().lat,
            b.getNorthEast().lng,
            b.getNorthEast().lat
        ]);
        setZoom(mapRef.current.getZoom());
    }

    let mapEdgeMinLongitude = ufficiData ? Math.min(...ufficiData?.map(x => x.longitudine ?? 0)) : 12.5;
    let mapEdgeMaxLongitude = ufficiData ? Math.max(...ufficiData?.map(x => x.longitudine ?? 0)) : 12.5;

    let mapEdgeMinLatitude = ufficiData ? Math.min(...ufficiData?.map(x => x.latitudine ?? 0)) : 42;
    let mapEdgeMaxLatitude = ufficiData ? Math.max(...ufficiData?.map(x => x.latitudine ?? 0)) : 42;

    if (mapEdgeMinLongitude == Infinity && mapEdgeMaxLongitude == -Infinity) {
        mapEdgeMinLongitude = 12.5;
        mapEdgeMaxLongitude = 12.5;
    }

    if (mapEdgeMinLatitude == Infinity && mapEdgeMaxLatitude == -Infinity) {
        mapEdgeMinLatitude = 42;
        mapEdgeMaxLatitude = 42;
    }

    const maxMarkersDistance = (mapEdgeMaxLatitude - mapEdgeMinLatitude) > (mapEdgeMaxLongitude - mapEdgeMinLongitude) ? (mapEdgeMaxLatitude - mapEdgeMinLatitude) : (mapEdgeMaxLongitude - mapEdgeMinLongitude);

    return (
        <>
            <MapContainer
                center={[(mapEdgeMinLatitude + mapEdgeMaxLatitude) / 2, (mapEdgeMinLongitude + mapEdgeMaxLongitude) / 2]}
                zoom={zoom ?? 6 + Math.log(2) / Math.log(9 / maxMarkersDistance)}
                minZoom={6}
                scrollWheelZoom={true}
                whenCreated={map => {
                    if (mapRef) {
                        mapRef.current = map;
                        updateMap();
                    }
                }}

                style={{ height: "100%", width: "100%" }}
                className="markercluster-map"
            >
                <LocationMarker />
                <MapOptions />
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {/* <SVGOverlay>
                    <svg viewBox="0 0 220 100" xmlns="http://www.w3.org/2000/svg" src="https://it.wikiversity.org/wiki/File:Italian_regions_provinces_white_no_labels.svg">

                    </svg>
                </SVGOverlay> */}
                {/* {clusters.map(cluster => {
                    // every cluster point has coordinates
                    const [longitude, latitude] = cluster.geometry.coordinates;

                    // the point may be either a cluster or a crime point
                    const {
                        cluster: isCluster,
                        point_count: pointCount
                    } = cluster.properties;

                    // we have a cluster to render
                    if (isCluster) {
                        return (
                            <Marker
                                key={`cluster-${cluster.id}`}
                                position={[latitude, longitude]}
                                icon={fetchIcon(
                                    pointCount,
                                    10 + (pointCount / points.length) * 40
                                )}
                            />
                        );
                    }

                    // we have a single point (crime) to render
                    return (
                        <UfficioMarker key={`crime-${cluster.properties.crimeId}`} ufficioData={cluster} markerRef={markerRefs} />
                    );
                })} */}
                {ufficiData?.map((ufficioData, index) => <UfficioMarker key={index} ufficioData={ufficioData} markerRef={markerRefs} />)}
            </MapContainer>
        </>
    );
}

